const encodeUriAll = (value: string): string => {
  return encodeURIComponent(value).replace(
    /[!*'()]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
  );
};

export default encodeUriAll;
